import * as React from 'react'
import { DisplayContent } from 'react-content-engine'
import { connect } from 'react-redux'

import { ListItem } from 'components/List'
import { Note } from '../../../data/models/funnelOrder/note'
import { Theme } from '../../../data/models/funnelOrder/theme'
import { AppState } from '../../../data/state'

interface NoteSummaryProps {
  theme: Theme
  note: Note
  loading: boolean
}

const NoteSummary: React.FC<NoteSummaryProps> = ({ note, loading, theme }) => {
  const loadingClass = loading ? 'is-loading' : ''
  let titleContentKey = `should-know-summary`
  if (theme === Theme.train) {
    titleContentKey += `-train`
  }

  return (
    <>
      {note.UseNote && note.NoteText ? (
        <ListItem>
          <span className={loadingClass}>
            <DisplayContent contentKey={titleContentKey}>
              Anything we should know?
            </DisplayContent>
            <p style={{ whiteSpace: 'pre-wrap' }}>{note.NoteText}</p>
          </span>
        </ListItem>
      ) : null}
    </>
  )
}

export default connect((state: AppState) => ({
  theme: state.funnelOrder.theme,
  note: state.funnelOrder.note,
  loading: state.contentEngine.loading,
}))(NoteSummary)
